import { version } from './version';

export const environment = {
  production: false,
  context: "STAGING",
  version: version,
  countries: ["es", "pt"],
  gtm: {
    id: 'GTM-KT85G4W',
    enabled: true,
    debug: true // active aussi ou non les logs pour l'envoie des donn�es anonymes
  },
  backEnd: {
    baseApi: "https://bricodepot-iberia-recette.azurewebsites.net/API/",
    byMe: {
      apiName: "ByMe/"
    },
    eventData:{
      apiName: "EventData/"
    }
  },
  bdi: {
    distributionCenterStoreId: "D056"
  },
  byMe: {
    webServiceURL: "https://staging-platform.enterprise.by.me",
    whiteListUrl: "https://staging-kitchen.enterprise.by.me",
    whiteListUrlBathroom: "https://staging-bathroom.enterprise.by.me",
    iframeVersion: 5,
    kitchenDistribIdEs: "BDI_KITCHEN_ES",
    kitchenDistribIdPt: "BDI_KITCHEN_PT",
    storageDistribIdEs: "BDI_STORAGE_ES",
    storageDistribIdPt: "BDI_STORAGE_PT",
    bathroomDistribIdEs: "BDI_BATHROOM_ES",
    bathroomDistribIdPt: "BDI_BATHROOM_PT"
  },
  magento: {
    whiteListUrls: [
      "http://localhost:4200",
      "http://local.bricodepot.test",
      "https://dev.bricodepot.es",
      "https://www.bricodepot.es",
      "https://www.bricodepot.pt",
      "https://www.bricodepot.test",
      "https://feature-hbm.ecommerce.np.bricodepot.es",
      "https://feature-testing-hbm.ecommerce.np.bricodepot.es",
      "https://feature-980-kitchens.ecommerce.np.bricodepot.es",
      "http://bricodepot.test",
      "https://bricodepot.test",
      "http://local-pt.bricodepot.test",
      "http://bricolocal.loca.lt",
      "https://feature-1351.ecommerce.np.bricodepot.es",
      "https://feature-1265-share-project-hbm.ecommerce.np.bricodepot.es",
      "https://pt.feature-1265-share-project-hbm.ecommerce.np.bricodepot.es",
      "https://feature-1583-hbmbystore.ecommerce.np.bricodepot.es",
      "https://pt.feature-1583-hbmbystore.ecommerce.np.bricodepot.es",
      "https://feature-1685.ecommerce.np.bricodepot.es",
      "https://pt.feature-1685.ecommerce.np.bricodepot.es"
    ],
    shareUrls: {
      es: {
        url: '/planificador-estancias',
        pages: {
          kitchen: '/planificador-cocinas',
          storage: '/planificador-armarios',
          bathroom: '/planificador-banos'
        }
      },
      pt: {
        url: '/planeamento-divisao',
        pages: {
          kitchen: '/planificador-cozinhas',
          storage: '/planificador-armarios',
          bathroom: '/planificador-banhos'
        }
      }
    }
  },
  debug: {
    enabled: false,
    searchTestId: "7ddb8112-58a3-41f0-a693-5644b8687a88"
  }
}